import type { CityConfig } from "../city-template/types";

export const hopewellVaConfig: CityConfig = {
  city: "Hopewell",
  state: "Virginia",
  stateAbbr: "VA",
  slug: "hopewell-va",
  route: "/cities/hopewell-va",
  title: "Emergency Passport Hopewell VA | Expedited Passport Services | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Hopewell, VA — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Hopewell, Petersburg, Colonial Heights, and the Tri-Cities area. Get your passport fast!",
  h1: "Emergency & Expedited Passport Services in Hopewell, VA",
  heroSubtitle: "Passport expired before your trip? Traveling from Hopewell, the Tri-Cities, or the confluence of the James and Appomattox Rivers? We help Hopewell travelers get expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Hopewell%20Virginia%20riverfront%20view%20at%20the%20confluence%20of%20the%20James%20and%20Appomattox%20Rivers%2C%20historic%20industrial%20waterfront%20with%20modern%20cityscape%20alongside%20the%20river%2C%20tree-lined%20residential%20streets%20with%20charming%20homes%20and%20Victorian%20architecture%2C%20the%20historic%20Beacon%20Theatre%20visible%20in%20the%20background%2C%20warm%20afternoon%20light%20with%20green%20riverbanks%20and%20blue%20sky%2C%20professional%20photography%20showcasing%20a%20historic%20Virginia%20river%20town%20with%20small-city%20charm%20and%20waterfront%20character%2C%20no%20people%20visible%2C%20scenic%20riverside%20landscape%20with%20industrial%20heritage%20and%20modern%20suburban%20elements&width=1800&height=700&seq=hopewell-va-hero-001&orientation=landscape",
  heroImageAlt: "Hopewell Virginia riverfront at the confluence of the James and Appomattox Rivers with historic waterfront and Beacon Theatre",
  geoPosition: "37.3043;-77.2872",
  geoPlacename: "Hopewell, Virginia",
  regionalAgency: {
    name: "Washington Passport Agency",
    address: "600 19th Street NW, Washington, DC 20006",
    distance: "Located in downtown Washington, DC — approximately 120 miles north of Hopewell via I-95 and I-295",
  },
  nearbyCitiesZips: [
    { name: "Hopewell", zips: "23860" },
    { name: "Petersburg", zips: "23803, 23804, 23805, 23806" },
    { name: "Colonial Heights", zips: "23834" },
    { name: "Chester", zips: "23831, 23836" },
    { name: "Fort Lee", zips: "23801" },
    { name: "Prince George", zips: "23875" },
    { name: "Charles City", zips: "23030" },
    { name: "Dinwiddie", zips: "23841" },
    { name: "Matoaca", zips: "23836" },
    { name: "Ettrick", zips: "23803" },
    { name: "Richmond", zips: "23218, 23219, 23220, 23221, 23222, 23223, 23224, 23225, 23226, 23227, 23228, 23229, 23230, 23231, 23233, 23234, 23235, 23236, 23237, 23238, 23242" },
    { name: "Midlothian", zips: "23112, 23113, 23114" },
    { name: "Glen Allen", zips: "23058, 23059, 23060" },
    { name: "Chesterfield", zips: "23832, 23838" },
    { name: "Henrico", zips: "23075, 23228, 23229, 23231, 23233, 23238, 23242, 23255" },
    { name: "Hanover", zips: "23005, 23009, 23015, 23047, 23059, 23069" },
    { name: "Emporia", zips: "23847" },
    { name: "Franklin", zips: "23851" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent travel departures from the Tri-Cities area" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Tri-Cities River Hub", desc: "Serving Hopewell, Petersburg, Colonial Heights, Fort Lee, and Chester" },
  ],
  internalLinks: [
    { name: "Virginia state passport services", route: "/states/virginia" },
    { name: "Petersburg VA passport services", route: "/cities/petersburg-va" },
    { name: "Richmond VA passport services", route: "/cities/richmond-va" },
    { name: "Colonial Heights VA passport services", route: "/cities/colonial-heights-va" },
    { name: "Chester VA passport services", route: "/cities/chester-va" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Hopewell remotely via secure courier. We do not have a walk-in office in Hopewell — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Hopewell and Tri-Cities area travelers.",
  fpcOfficeDistance: "Serving all of Hopewell and the Tri-Cities area including Petersburg, Colonial Heights, Fort Lee, Chester, Prince George, Charles City, and Dinwiddie",
  serviceAreaIntro: "From the historic riverfront of Hopewell at the confluence of the James and Appomattox Rivers to the suburban neighborhoods of Westover and City Point, from the industrial heritage of the downtown to the quiet residential areas near the city limits, from the nearby communities of Prince George and Charles City to the Tri-Cities bustle of Petersburg and Colonial Heights — Fast Passport Center serves every corner of Hopewell and the surrounding region. We regularly help travelers from the river towns, Fort Lee military families, and the Richmond-Petersburg corridor get their passports fast.",
  nearbyCitiesIntro: "We serve all Hopewell neighborhoods and the Tri-Cities area including Petersburg, Colonial Heights, Fort Lee, Chester, Prince George, Charles City, and Dinwiddie.",
  howItWorksIntro: "Most Hopewell travelers complete everything online and ship documents overnight. No need to drive to the Washington regional agency or wait in long government lines.",
  mistakesIntro: "Hopewell travelers often face the temptation to drive to the Washington regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Hopewell and Tri-Cities area travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Hopewell? Here are the most common ones we hear from Tri-Cities area travelers.",
  statePageRoute: "/states/virginia",
  statePageName: "Virginia",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–3",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Hopewell international flights and last-minute travel.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Jennifer L.",
      location: "Hopewell, VA",
      rating: 5,
      text: "I needed an emergency passport for a family emergency overseas with only 4 days notice. Fast Passport Center had my passport in 48 hours. I shipped from the UPS on Oaklawn Boulevard and the whole process was incredibly smooth. Best service in the Tri-Cities area.",
      service: "Emergency Passport",
    },
    {
      name: "Robert C.",
      location: "Hopewell, VA",
      rating: 5,
      text: "As a Hopewell resident, I was worried about finding expedited passport services without driving to Richmond or DC. Fast Passport Center made it incredibly easy. Everything was done online, and my renewal was back in 5 days. The convenience is unbeatable.",
      service: "Passport Renewal",
    },
    {
      name: "Angela W.",
      location: "Prince George, VA",
      rating: 5,
      text: "First passports for my three kids before a Disney cruise. Fast Passport Center handled all the parental consent requirements and had the passports in 6 days. For families in the Hopewell and Prince George area, this is the best service available.",
      service: "Child Passport",
    },
    {
      name: "Marcus D.",
      location: "Hopewell, VA",
      rating: 5,
      text: "Lost my passport 3 days before a business trip to Toronto. I was in panic mode. Fast Passport Center had a replacement in my hands in 36 hours. They saved my business trip. Hopewell professionals need this service.",
      service: "Lost Passport",
    },
  ],
  facilities: [
    {
      id: "hopewell-va-1",
      name: "Hopewell Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "117 W Broadway",
      city: "Hopewell",
      state: "VA",
      zip: "23860",
      phone: "(804) 458-2721",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Hopewell",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Hopewell facility. Full passport services with appointment. Call ahead to confirm.",
      icon: "ri-mail-line",
    },
    {
      id: "hopewell-va-2",
      name: "Petersburg Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "120 N Sycamore St",
      city: "Petersburg",
      state: "VA",
      zip: "23803",
      phone: "(804) 733-2521",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Petersburg, south of Hopewell",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Petersburg and nearby Hopewell residents. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "hopewell-va-3",
      name: "Colonial Heights Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1201 Boulevard",
      city: "Colonial Heights",
      state: "VA",
      zip: "23834",
      phone: "(804) 526-6500",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM; Sat: 9:00 AM – 12:00 PM",
      distance: "Colonial Heights, south of Hopewell",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Colonial Heights and Tri-Cities area. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "hopewell-va-4",
      name: "Chester Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "12501 Jefferson Davis Hwy",
      city: "Chester",
      state: "VA",
      zip: "23831",
      phone: "(804) 748-1221",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Chester, north of Hopewell",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Chester and Chesterfield County. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "hopewell-va-5",
      name: "Fort Lee ID Card Office",
      type: "Military Facility",
      address: "Fort Lee, Bldg 9020",
      city: "Fort Lee",
      state: "VA",
      zip: "23801",
      phone: "(804) 734-4200",
      hours: "Mon–Fri: 8:00 AM – 3:00 PM",
      distance: "Fort Lee, near Hopewell",
      website: "https://home.army.mil/lee",
      websiteLabel: "Fort Lee",
      notes: "Military ID and passport services for active duty and dependents. Appointment required. Call ahead for current passport acceptance hours.",
      icon: "ri-building-2-line",
    },
    {
      id: "hopewell-va-6",
      name: "Prince George County Clerk",
      type: "County Clerk",
      address: "P.O. Box 68",
      city: "Prince George",
      state: "VA",
      zip: "23875",
      phone: "(804) 722-8600",
      hours: "Mon–Fri: 8:30 AM – 4:30 PM",
      distance: "Prince George, near Hopewell",
      website: "https://www.princegeorgeva.org",
      websiteLabel: "Prince George County",
      notes: "Provides vital records and birth certificates. Not a passport acceptance facility but useful for document collection.",
      icon: "ri-building-2-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 2+ hour drive to DC", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Hopewell photo shops often use generic sizes. Passport photos must be exactly 2x2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Tri-Cities acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Hopewell applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Washington DC regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Hopewell families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Hopewell travelers often assume standard processing will be fine. It takes 8-11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Hopewell or nearby." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Hopewell address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Hopewell before my international trip?", a: "Yes. Fast Passport Center provides emergency passport services in Hopewell for travelers with urgent international departures. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24-48 hour turnaround — perfect for last-minute trips from the Tri-Cities area and the riverfront communities." },
    { q: "How fast can I renew my passport in Hopewell?", a: "Fast Passport Center offers fast passport renewal in Hopewell in as little as 24-48 hours through our emergency courier service. For less urgent travel, our 3-5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Hopewell?", a: "The nearest regional passport agency to Hopewell is the Washington Passport Agency, located approximately 120 miles north in downtown Washington, DC. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24-48 hour turnaround from Hopewell." },
    { q: "Can I get a same-day passport appointment near Hopewell?", a: "Same-day passport appointments are only available at the Washington Regional Passport Agency for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24-48 hour emergency courier processing is the fastest guaranteed option for Hopewell residents." },
    { q: "Can I expedite a child passport in Hopewell?", a: "Yes. Fast Passport Center expedites child passports in Hopewell for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Hopewell and Tri-Cities families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Hopewell with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24-48 hours." },
    { q: "How fast can I get a passport in Hopewell?", a: "With Fast Passport Center's emergency courier service, Hopewell travelers can receive their passport in as little as 24-48 hours. Our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities, bypassing standard mail delays." },
    { q: "Do I need to drive to the Washington Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
    { q: "Where are the closest passport acceptance facilities near Hopewell?", a: "Popular options include the Hopewell Post Office (23860), Petersburg Post Office (23803), Colonial Heights Post Office (23834), and Chester Post Office (23831). All require appointments. We help you find the most convenient location and schedule your visit." },
    { q: "What if I live in Prince George, Charles City, or Fort Lee?", a: "We serve the entire Tri-Cities area including Prince George, Charles City, Fort Lee, Petersburg, Colonial Heights, and Chester. Our overnight shipping labels work from any UPS location, so your location doesn't affect processing speed." },
    { q: "How much does expedited passport service cost in Hopewell?", a: "Government fees are fixed: $130 for a passport book (adult) plus a $60 expedite fee. Fast Passport Center's service fees vary by processing speed — emergency 24-48 hour processing, 3-5 day expedited, or standard options. Contact us for a personalized quote." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Hopewell", address: "900 W Broadway, Hopewell, VA 23860", hours: "Mon-Sun: 8AM-10PM" },
    { name: "Walmart — Hopewell", address: "201 Campbell Ave, Hopewell, VA 23860", hours: "Mon-Sun: 6AM-11PM" },
    { name: "CVS Pharmacy — Petersburg", address: "2050 S Crater Rd, Petersburg, VA 23805", hours: "Mon-Sun: 8AM-10PM" },
    { name: "Walgreens — Colonial Heights", address: "1000 Southpark Blvd, Colonial Heights, VA 23834", hours: "Mon-Sun: 7AM-11PM" },
    { name: "CVS Pharmacy — Chester", address: "12300 Jefferson Davis Hwy, Chester, VA 23831", hours: "Mon-Sun: 8AM-10PM" },
    { name: "Walmart — Petersburg", address: "3500 S Crater Rd, Petersburg, VA 23805", hours: "Mon-Sun: 6AM-11PM" },
  ],
  dmvLocations: [
    {
      name: "Virginia DMV — Hopewell",
      address: "209 W Broadway, Hopewell, VA 23860",
      hours: "Mon-Fri: 8AM-5PM",
      note: "Driver's license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "Virginia DMV — Colonial Heights",
      address: "201 Temple Ave, Colonial Heights, VA 23834",
      hours: "Mon-Fri: 8AM-5PM",
      note: "REAL ID and passport-related ID services. Appointment recommended.",
      featured: false,
    },
    {
      name: "Virginia DMV — Petersburg",
      address: "1330 E Wythe St, Petersburg, VA 23803",
      hours: "Mon-Fri: 8AM-5PM",
      note: "REAL ID and passport-related ID services. Appointment recommended.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "RIC",
      name: "Richmond International Airport",
      distance: "Approximately 20 miles north of Hopewell",
      address: "1 Richard E. Byrd Terminal Dr, Richmond, VA 23250",
      note: "The closest major airport. Domestic and limited international flights. Accessible via I-95.",
      flightUrl: "https://www.flyrichmond.com/",
      flightLabel: "RIC Airport",
      featured: true,
    },
    {
      code: "PHF",
      name: "Newport News/Williamsburg International Airport",
      distance: "Approximately 55 miles east of Hopewell",
      address: "900 Bland Blvd, Newport News, VA 23602",
      note: "Regional airport. Accessible via I-64.",
      flightUrl: "https://www.flyphf.com/",
      flightLabel: "PHF Airport",
      featured: false,
    },
    {
      code: "ORF",
      name: "Norfolk International Airport",
      distance: "Approximately 70 miles southeast of Hopewell",
      address: "2200 Norview Ave, Norfolk, VA 23518",
      note: "Regional hub for Hampton Roads. Accessible via I-95 and I-64.",
      flightUrl: "https://www.norfolkairport.com/",
      flightLabel: "ORF Airport",
      featured: false,
    },
    {
      code: "DCA",
      name: "Ronald Reagan Washington National Airport",
      distance: "Approximately 120 miles north of Hopewell",
      address: "2401 Smith Blvd, Arlington, VA 22202",
      note: "Major international hub for DC metro area. Accessible via I-95.",
      flightUrl: "https://www.flyreagan.com/",
      flightLabel: "DCA Airport",
      featured: false,
    },
  ],
};